import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: { usage: 'Использование', tabUsage: 'Расход', tabPayments: 'Платежи' },
  en: { usage: 'Usage', tabUsage: 'Spending', tabPayments: 'Payments' },
})
